import type { FC } from "react";
import type { ICategory } from "app/common/services/categoryService.types";
import type { IProModal } from "pro-features/components/Modals/src/ProModal";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { DeleteIndustryConfirm } from "app/pages/industry-analysis/home/DeleteIndustryConfirm";

interface IDeleteIndustryModal {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    industry: ICategory;
    onDelete: VoidFunction;
}

export const DeleteIndustryModal: FC<IDeleteIndustryModal> = (props) => {
    const { isOpen, setIsOpen, industry, onDelete } = props;
    const onClose = () => setIsOpen(false);
    const proModalProps: IProModal = {
        showCloseIcon: false,
        customStyles: { content: { padding: 0, width: "auto" } },
        onCloseClick: onClose,
        isOpen,
    };
    return (
        <ProModal {...proModalProps}>
            <DeleteIndustryConfirm
                onClose={onClose}
                industry={industry}
                onDelete={onDelete}
            />
        </ProModal>
    );
};
